export function AcademySettingsSvg() {
    return {
        restrict: 'E',
        scope: true,
        template: `<ng-include class="d-contents" src="'../hui/modules/svg/academy-settings.svg'"></ng-include>`
    }
}